/**
 * Named type roles. Components use `textStyle="cardTitle"` rather than picking
 * sizes and weights ad hoc — that is what keeps hierarchy consistent.
 *
 * Headings tighten their tracking, body stays at zero, metrics and table numbers
 * use tabular figures. Semibold is the heaviest weight in the product; bold is
 * reserved for the authentication display line.
 */
export const textStyles = {
  /** Authentication screen only — the one place a larger line is warranted. */
  display: {
    value: {
      fontSize: '4xl',
      fontWeight: 'bold',
      lineHeight: 'tight',
      letterSpacing: 'tighter',
      color: 'text.primary',
    },
  },
  pageTitle: {
    value: {
      fontSize: '2xl',
      fontWeight: 'semibold',
      lineHeight: 'tight',
      letterSpacing: 'tighter',
      color: 'text.primary',
    },
  },
  pageDescription: {
    value: { fontSize: 'md', fontWeight: 'normal', lineHeight: 'normal', color: 'text.secondary' },
  },
  sectionTitle: {
    value: {
      fontSize: 'xl',
      fontWeight: 'semibold',
      lineHeight: 'snug',
      letterSpacing: 'tight',
      color: 'text.primary',
    },
  },
  cardTitle: {
    value: {
      fontSize: 'lg',
      fontWeight: 'semibold',
      lineHeight: 'snug',
      letterSpacing: 'tight',
      color: 'text.primary',
    },
  },
  metricValue: {
    value: {
      fontSize: '3xl',
      fontWeight: 'semibold',
      lineHeight: 'none',
      letterSpacing: 'tighter',
      color: 'text.primary',
      fontVariantNumeric: 'tabular-nums',
    },
  },
  body: {
    value: { fontSize: 'md', fontWeight: 'normal', lineHeight: 'normal', color: 'text.primary' },
  },
  bodySmall: {
    value: { fontSize: 'sm', fontWeight: 'normal', lineHeight: 'normal', color: 'text.primary' },
  },
  bodyStrong: {
    value: { fontSize: 'md', fontWeight: 'medium', lineHeight: 'normal', color: 'text.primary' },
  },
  bodySecondary: {
    value: { fontSize: 'md', fontWeight: 'normal', lineHeight: 'normal', color: 'text.secondary' },
  },
  label: {
    value: { fontSize: 'md', fontWeight: 'medium', lineHeight: 'snug', color: 'text.primary' },
  },
  helperText: {
    value: { fontSize: 'xs', fontWeight: 'normal', lineHeight: 'snug', color: 'text.secondary' },
  },
  caption: {
    value: { fontSize: '2xs', fontWeight: 'normal', lineHeight: 'snug', color: 'text.muted' },
  },
  /** Sentence case, not uppercase: headers should read, not shout. */
  tableHeading: {
    value: { fontSize: 'xs', fontWeight: 'medium', lineHeight: 'snug', color: 'text.secondary' },
  },
  tableCell: {
    value: { fontSize: 'sm', fontWeight: 'normal', lineHeight: 'snug', color: 'text.primary' },
  },
  numeric: {
    value: {
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'snug',
      color: 'text.primary',
      fontVariantNumeric: 'tabular-nums',
    },
  },
  navLabel: {
    value: { fontSize: 'md', fontWeight: 'medium', lineHeight: 'snug', letterSpacing: 'tight' },
  },
  badgeText: {
    value: { fontSize: '2xs', fontWeight: 'medium', lineHeight: 'snug' },
  },
}
